import { getCustomerUrl } from '@weike/services';
import { isProduction } from '../core/env';
const env = isProduction() ? 'production' : 'development'

export function getOrderCustomerUrl(orderId) {
  return getCustomerUrl(env, {
    type: 'invoice_id',
    id: orderId
  }).then(res => {
    return res.customer_url
  })
}

export function getPhysicalOrderCustomerUrl(orderId) {
  return getCustomerUrl(env, {
    type: 'physical_order_id',
    id: orderId
  }).then(res => {
    return res.customer_url
  })
}


export function getLiveRoomCustomerUrl(liveroom_id) {
  return getCustomerUrl(env, {
    type: 'liveroom_id',
    id: liveroom_id
  }).then(res => {
    return res.customer_url
  })
}



// WEBPACK FOOTER //
// ./src/services/common.js